import Q2TableModelBase from "./q2_table_model_base";
import { Q2Game } from "../../net/proto/q2_game";
import NetMessageDataQ2Game from "../../net/q2_net_msg_data_game";

const { ccclass, property } = cc._decorator;


@ccclass
export default class Q2TableModel extends Q2TableModelBase {
    
    send_more_card_req(){
        let protoData: Q2Game.IMoreCardReq = {

        }
        this.sendMsg(NetMessageDataQ2Game.MoreCard, protoData)
    }

    send_discard_req(card: number){
        let protoData: Q2Game.IDiscardReq = {
            card: card,
        }
        this.sendMsg(NetMessageDataQ2Game.Discard, protoData)
    }

    send_raise_req(cards: number[], targetCards: number[]){
        let protoData: Q2Game.IRaiseReq = {
            cards: cards,
            targetCards: targetCards,
        }
        this.sendMsg(NetMessageDataQ2Game.Raise, protoData)
    }

    send_attach_req(targetSeatId: number, card: number, targetCards: number[]){
        let protoData: Q2Game.IAttachReq = {
            targetSeat: targetSeatId,
            card: card,
            targetCards: targetCards,
        }
        this.sendMsg(NetMessageDataQ2Game.Attach, protoData)
    }

    send_storage_req(cards: number[]){
        let protoData: Q2Game.IStorageReq = {
            cards: cards,
        }
        this.sendMsg(NetMessageDataQ2Game.Storage, protoData)
    }

    send_cards_sequence_change_req(cards: number[]){
        let protoData: Q2Game.ICardsSequenceChangedReq = {
            cards: cards,
        }
        this.sendMsg(NetMessageDataQ2Game.CardsSequenceChangedReq, protoData)
    }

    send_show_q2_req(show: boolean){
        let protoData: Q2Game.IShowQ2Req = {
            isReq: show,
        }
        this.sendMsg(NetMessageDataQ2Game.ShowQ2, protoData)
    }

    send_complete_req(confirm: boolean){
        let protoData: Q2Game.ICompleteReq = {
            isReq: confirm,
        }
        this.sendMsg(NetMessageDataQ2Game.Complete, protoData)
    }

}